import { render, staticRenderFns } from "./PieD3.vue?vue&type=template&id=2169c0de"
import script from "./PieD3.vue?vue&type=script&lang=ts"
export * from "./PieD3.vue?vue&type=script&lang=ts"
import style0 from "./PieD3.vue?vue&type=style&index=0&id=2169c0de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports